import { type HTMLAttributes } from 'react';
import clsx from 'clsx';

export function Card({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={clsx(
        'glass rounded-3xl p-5 shadow-soft',
        className,
      )}
      {...rest}
    />
  );
}
